/**
 * Helper functions for comparing arrays and typed arrays
 * @module
 */

export function compareArrays<T>(
  a: T[] | null | undefined,
  b: T[] | null | undefined,
  cmp: (a: T, b: T) => boolean,
): boolean {
  if (a === undefined || b === undefined || a === null || b === null) {
    return a === b;
  }
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0, l = a.length; i < l; i++) {
    if (!cmp(a[i], b[i])) {
      return false;
    }
  }
  return true;
}

type TypedArray =
  | Int8Array
  | Uint8Array
  | Uint8ClampedArray
  | Int16Array
  | Uint16Array
  | Int32Array
  | Uint32Array
  | Float32Array
  | Float64Array
  | BigInt64Array
  | BigUint64Array;

export function compareTypedArrays(a: TypedArray | undefined | null, b: TypedArray | undefined | null) {
  if (a === undefined || b === undefined || a === null || b === null) {
    return a === b;
  }
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0, l = a.length; i < l; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
}
